import { IconSettings } from '@graphql/gql/graphql';

type ReassignedIconsLookup = {
  [uuid: string]: string;
};

export interface IconSettingsWithLookup extends IconSettings {
  reassignedIconsLookup: ReassignedIconsLookup;
}

/**
 * Creates a lookup object from the icons array of the ThemeSettings that maps the default carina icon names to their
 * reassigned values by the planner.
 */
function getReassignedIconsLookup(icons: IconSettings): ReassignedIconsLookup {
  if (!Array.isArray(icons?.reassignedIcons) || icons?.reassignedIcons?.length === 0) {
    return null;
  }

  const reassignedIconsLookup = icons?.reassignedIcons?.reduce((acc, icon) => {
    acc[icon.name] = icon.reassignment;
    return acc;
  }, {} as ReassignedIconsLookup);
  return reassignedIconsLookup;
}

export default getReassignedIconsLookup;
